import React from 'react';

export default function DispensationOriginBadge({ sourceType, compact = false }) {
  const isRx = sourceType === 'PRESCRIPTION';
  if (compact) {
    return (
      <span
        className={`cp-dispense-origin cp-dispense-origin--${isRx ? 'rx' : 'manual'}`}
        title={isRx ? 'Ordonnance médecin' : 'Saisie pharmacie'}
      >
        {isRx ? 'Rx' : 'Manuel'}
      </span>
    );
  }
  return (
    <span className={`cp-dispense-origin cp-dispense-origin--${isRx ? 'rx' : 'manual'} cp-dispense-origin--lg`}>
      {isRx ? 'Ordonnance médecin' : 'Saisie manuelle'}
    </span>
  );
}

export function formatConsultationRef(id) {
  if (id == null || id === '') return null;
  const n = Number(id);
  if (!Number.isFinite(n) || n < 0) return null;
  const digits = Math.max(4, String(Math.trunc(n)).length);
  return `n° ${String(Math.trunc(n)).padStart(digits, '0')}`;
}
